import { registerActivity } from "../../../registry";
import { SlotType, WorkflowActivityDefinition } from "../../../types";

export type AutonomousModeDynamicOutputs = {
  [key: string]: SlotType[];
  'intentions': SlotType<string>[];
};

export const AutonomousMode: WorkflowActivityDefinition<AutonomousModeDynamicOutputs> = {
  group: 'chatbot',
  name: 'chatbot-autonomous-mode',
  type: 'activity',
  isFlowControl: true,
  schema: {
    type: 'object',
    properties: {
      intentions: {
        title: 'Intentions',
        type: 'array',
        default: [],
        items: {
          type: 'object',
          properties: {
            name: {
              type: 'string',
            },
            description: {
              type: 'string',
            },
          },
        },
      },
    },
    required: [],
  },
  defaults: {
    intentions: [],
  },
  inputs: [
    {
      name: 'inFlow',
      type: 'flowControl',
    },
    {
      name: 'message',
      type: 'text',
    },
  ],
  outputs: [
    {
      name: 'outFlow',
      type: 'flowControl',
    },
  ],
  hasDynamicOutputs: true,
  dynamicOutputs: {
    intentions: [
      {
        name: 'intention',
        type: 'text',
        choices: [],
      },
    ],
  },
};

registerActivity(AutonomousMode);
